import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const BreadcrumbWrapper = styled.div<{ newPdDesign?: boolean }>`
  max-width: 64.6875rem;
  font-size: 0.75rem;
  padding: 1rem 0 0 0;
  display: block;

  ${({ newPdDesign }) =>
    newPdDesign
      ? css`
          ${theme.typography.labelRegular400}
          font-size: 0.75rem;
          padding: 1rem 0 1.5rem;

          @media (min-width: ${breakpoints.lg}) {
            padding: 1.25rem 0 1.5rem;
          }
        `
      : css`
          @media (min-width: ${breakpoints.md}) {
            padding: 1rem 0 1rem;
          }
        `}
`;
